import { lazy } from 'react'

import MainLayout from 'layout/MainLayout'
import Loadable from 'ui-component/Loadable'

const FlipCards = Loadable(lazy(() => import('pages/FlipCards/FlipCards')))
const Notes = Loadable(lazy(() => import('pages/Notes/Notes')))

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout/>,
  children: [
    {
      path: '/home',
      element: <FlipCards/>
    }
    // {
    //   path: '/notes',
    //   element: <Notes/>
    // }
  ]
}

export default MainRoutes
